import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import api from '../../../api/axios';
import { IApiResponseError, IApiState } from '../../../types/api';
import { RootState } from '../..';

export interface ICircuitProductsData {
  productId: string;
  title: string;
  dateTime: string;
  description: string;
  offerCountdown: string;
  price: number;
  ticketValidTill: string[];
}

export interface IGetCircuitProductsResponse {
  status: boolean;
  message: string;
  data: ICircuitProductsData[];
  errors?: IApiResponseError[];
}

const initialState: IApiState<IGetCircuitProductsResponse> = {
  value: null,
  status: 'idle',
  error: '',
};

export const getCircuitProductsAsync = createAsyncThunk(
  'getCircuitProducts',
  async (_, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;
      const accessToken = state.auth.value?.data?.token?.accessToken;
      const config = {
        headers: {
          Authorization: `Token ${accessToken}`,
        },
      };
      const { data } = await api.get('billers/circuit/products-afcon', config);
      return data;
    } catch (err) {
      const error = err as AxiosError<IGetCircuitProductsResponse>;
      return rejectWithValue(error.response?.data);
    }
  }
);

export const circuitProductsFetchSlice = createSlice({
  name: 'circuitProducts/get',
  initialState,
  reducers: {
    resetGetCircuitProducts: (state) => {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builders) => {
    builders
      .addCase(getCircuitProductsAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(getCircuitProductsAsync.fulfilled, (state, action) => {
        state.status = 'success';
        state.value = action.payload as IGetCircuitProductsResponse;
      })
      .addCase(getCircuitProductsAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.value = action.payload as IGetCircuitProductsResponse;
        state.error = action.error.message;
      });
  },
});

export const { resetGetCircuitProducts } = circuitProductsFetchSlice.actions;

export default circuitProductsFetchSlice.reducer;
